import { TableRow } from '@mui/material';
import IMedicalCertificate from '../../interfaces/IMedicalCertificate';
import { getStickyProps, HeaderConfig } from '../../hooks/util/useStickTable';
import { HeadTableCell } from '../../components/custom-table-sort-label/CustomTableSortLabel.styled';

interface IRowProps {
  medicalCertificate: IMedicalCertificate;
  handleClick: (medicalCertificate: IMedicalCertificate) => void;
  seeCid?: boolean;
  headers: HeaderConfig[];
}

const FollowupReportListRow = (props: IRowProps, indx: number) => {
  const medicalCertificate = props.medicalCertificate;

  return (
    <>
      <TableRow key={`${indx}`}>
        {props.headers.map((head, index) => (
          <HeadTableCell key={head.field} sx={getStickyProps(props.headers, index)}>
            {head.render
              ? head.render(medicalCertificate)
              : (medicalCertificate as Record<string, any>)[head.field] ?? ''}
          </HeadTableCell>
        ))}
      </TableRow>
    </>
  );
};

export default FollowupReportListRow;
